module.exports = __webpack_public_path__ + "static/media/parteCinco.e869657e.jpg";